import { Validator } from '~/utils/basicValidation';
import i18n from '~/i18n';

export const addressValidator: Validator = async (_, value) => {
  for (let i = 0; i < value?.length; i++) {
    const currentChar = value[i];
    const code = currentChar.charCodeAt(0);
    const isFirst = i === 0;
    const isLast = i === value.length - 1;
    const prevChar = isFirst ? undefined : value[i - 1];
    if (prevChar === ' ' && currentChar === ' ') {
      throw new Error(i18n.t("Character ' ' (space) should not appear two or more times consecutively"));
    }
    if (currentChar === ' ' && (isFirst || isLast)) {
      throw new Error(i18n.t("Character ' ' (space) should not be first or last character"));
    }
    if (
      !(code > 64 && code < 91) && // upper alpha (A-Z)
      !(code > 96 && code < 123) && // lower alpha (a-z)
      !(code > 47 && code < 58) && // numbers
      !(currentChar === ' ')
    ) {
      return Promise.reject(new Error(i18n.t('Must includes only numbers and letter')));
    }
  }
  return Promise.resolve();
};
